module.exports = __webpack_public_path__ + "static/media/newpreviouspaper.60bbc840.png";